import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class WalletEarning {
  @Expose({ name: 'total_earnings' })
  totalEarnings: string;

  @Expose({ name: 'recent_earnings' })
  @Type(() => WalletBonusTransaction)
  recentEarnings?: WalletBonusTransaction[];

  @Expose({ name: 'earnings_datewise' })
  earningsDatewise: Record<string, string>;

  @Expose({ name: 'earnings_datewise_grouped' })
  @Type(() => GroupedEarning)
  groupedEarning: GroupedEarning[];

  @Expose({ name: 'bonus_labels' })
  bonusLabels?: Record<string, string>;

  @Expose({ name: 'bonus_types' })
  bonusTypes?: string[];

  constructor(
    totalEarnings: string,
    recentEarnings: WalletBonusTransaction[],
    earningsDatewise: Record<string, string>,
    groupedEarning: GroupedEarning[],
    bonusLabels?: Record<string, string>,
    bonusTypes?: string[]
  ) {
    this.totalEarnings = totalEarnings;
    this.recentEarnings = recentEarnings;
    this.earningsDatewise = earningsDatewise;
    this.groupedEarning = groupedEarning;
    this.bonusLabels = bonusLabels;
    this.bonusTypes = bonusTypes;
  }

  static fromJson(json: Record<string, any>): WalletEarning {
    return plainToInstance(WalletEarning, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class WalletBonusTransaction {
  id: number;

  @Expose({ name: 'amount_generated' })
  amount: string;

  tax: string;

  @Expose({ name: 'service_charge' })
  serviceCharge: string;

  @Expose({ name: 'bonus_type' })
  type: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  level?: number;

  @Expose({ name: 'from_user' })
  fromUser?: string;

  @Expose({ name: 'rank_name' })
  rankName?: string;

  constructor(
    id: number,
    amount: string,
    tax: string,
    serviceCharge: string,
    type: string,
    dateCreated: Date,
    level?: number,
    fromUser?: string,
    rankName?: string
  ) {
    this.id = id;
    this.amount = amount;
    this.tax = tax;
    this.serviceCharge = serviceCharge;
    this.type = type;
    this.dateCreated = dateCreated;
    this.level = level;
    this.fromUser = fromUser;
    this.rankName = rankName;
  }

  static fromJson(json: Record<string, any>): WalletBonusTransaction {
    return plainToInstance(WalletBonusTransaction, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class GroupedEarning {
  total: string;

  @Expose({ name: 'bonus_type' })
  type: string;

  constructor(total: string, type: string) {
    this.total = total;
    this.type = type;
  }

  static fromJson(json: Record<string, any>): GroupedEarning {
    return plainToInstance(GroupedEarning, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
